import "./Home.css";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import checkPermission from "constants/permission";

interface NewHomeProps {
  orderSetting: React.ReactNode;
  quotesSetting: React.ReactNode;
  renderMasterSettings: React.ReactNode;
  stockSetting: React.ReactNode;
}

const masterManagement = [
  { title: "商品管理", path: "/mst-item" },
  { title: "分類管理", path: "/mst-category" }, // R
  { title: "タイヤ管理", path: "/mst-store/tire-list" },
  { title: "店舗管理", path: "/mst-store" }, // R
  { title: "ホイール管理", path: "/mst-wheel" },
  { title: "企業管理", path: "/mst-yh-company" }, // R
  { title: "商品オプション", path: "/mst-option" },
  { title: "得意先管理", path: "/mst-client" }, // R
  { title: "CSVアップロード", path: "/mst-csv" },
  { title: "仕入先管理", path: "/mst-vendor" }, // R
  { title: "利用者管理", path: "/mst-user" }, // R
];

/**
 * NewHome component
 * @param {NewHomeProps} props - NewHomeProps
 * @returns {React.ReactNode} NewHome component
 */
function NewHome({ orderSetting, quotesSetting, renderMasterSettings, stockSetting }: NewHomeProps) {
  return (
    <Box className="container new-home">
      <Box
        sx={{
          width: {xs: '100%', lg: "calc((100% - 120px) / 2)"},
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {quotesSetting}
        {renderMasterSettings}
        <Box className="box">
          <Box className="title" sx={{ backgroundColor: "var(--primary-500)" }}>
            マスタ管理
          </Box>
          <div className="items-group">
            {masterManagement.map(
              (item) =>
                checkPermission(item.path) && (
                  <Box
                    key={item.title}
                    className="item"
                    sx={{ px: 0, pl: "10px", mt: 0, mb: 2, justifyItems: "end" }}
                  >
                    <Link
                      className="item-title management-title note-box"
                      style={{ padding: "9px 16px 11px", textAlign: "center" }}
                      to={item.path}
                    >
                      {item.title}
                    </Link>
                  </Box>
                ),
            )}
          </div>
        </Box>
      </Box>
      <Box
        sx={{
          width: {xs: '100%', lg: "calc((100% - 120px) / 2)"},
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {orderSetting}
        {stockSetting}
      </Box>
    </Box>
  );
}

export default NewHome;
